export enum NotificationType {
  DOUBT = "DOUBT_RESPONSE",
  INDICATION = "INDICATION_RESPONSE",
  NEW_TRAINING = "NEW_TRAINING_RESPONSE",
  NEW_NOTIFICATION_WITH_IMAGE = "NEW_NOTIFICATION_WITH_IMAGE",
}
